export class PaymentTypeModel {
  accountNumber: string;
  bankCode: string;
  variableSymbol?: string;
  specificSymbol?: string;
  constantSymbol?: string;
  paymentType: string;
}
